module.exports = {
    apiBase: 'https://cat.api.firstdata.com',
    accreditationUrl: 'https://credenciamento-uat.portalfd.com.br',
    adminUrl: 'https://credenciamento-admin-uat.portalfd.com.br',
    conciliatorUrl: 'https://conciliadora-uat.portalfd.com.br'
};
